// SonglistCard.tsx
import React, { useState, useEffect, useRef } from 'react';
import {
  Card, CardBody, CardHeader, Button, Input, FormGroup, Label, Row, Col, Collapse, Modal, ListGroup, ListGroupItem, ModalHeader, ModalBody, ModalFooter, Spinner
} from 'reactstrap';
import { Trash, Eye, Plus, Music, Youtube, FileText, Video } from 'react-feather';
import Select, { MultiValue } from "react-select";
import './style.scss';
import { signedURL, uploadResourse, addResource, addSong, getSongLevel, addSongWithLevel, removeSongFromLevel, editSong, getTags } from '../../../../Api/lms/apiUtils';
import SongSearchComponent from './searchSong';
import { toBeRequired } from '@testing-library/jest-dom/matchers';
import PreviewModal from './songpreview';
import { toast } from "react-toastify";
import { LuMic2 } from "react-icons/lu";
import { GiMusicalScore } from "react-icons/gi";
import { CiEdit } from "react-icons/ci";
import { tagsMap } from './tags';
import { IoMusicalNotes } from 'react-icons/io5'; 
import { FaMusic, FaMicrophone, FaHeadphones, FaVideo } from 'react-icons/fa';




interface TagOption {
  value: number;
  label: string;
}

type UploadedFiles = {
  lyricsId?: string | null;
  annotationId?: string | null;
  songId1?: string | null;
  songId2?: string | null;
  demoTrackId1?: string | null;
  demoTrackId2?: string | null;
  karaokeId1?: string | null;
  karaokeId2?: string | null;
  backingTrackId1?: string | null;
  backingTrackId2?: string | null;
  songNotesId?: string | null;
};


interface Song {
  name: string;
  songUrl: string;
  mainSongFile1: File | null;
  mainSongFile2: File | null;
  mainLink: string;
  karaokeLink: string;
  karaokeFile1: File | null;
  karaokeFile2: File | null;
  notation_link: string;
  annotationFile: File | null;
  lyricsFile: File | null;
  backingTrackFile1: File | null;
  backingTrackFile2: File | null;
  demoTrackLink: string;
  demoTrackFile1: File | null;
  demoTrackFile2: File | null;
  karaokeAudioFile?: File | null;
  karaokeVideoFile?: File | null;
  kidFriendly: boolean;
  backingTrackLink?: string;
  songsNotesFile?: File | null;
}
interface FetchedSong {
  song_id: any;
  song_name: any;
  song_notes_id:any;
  backingTrackFile1:any;
  backingTrackFile2:any;
  songsNotesFile:any;
  demoTrackFile:any;
  tags:any;
  backingTrackUrl:any;
  backingTrackTwoUrl:any;
  backingTrackOneUrl:any;
  karaokeVideoUrl:any;
  karaokeAudioUrl:any;
  karaokeFile1: any;
  karaokeFile2:any
  mainSongUrl:any;
  song_url: any;
  songNotesFileUrl:any;
  demo_track_url:any;
  backing_track_url:any;
  backingTrackFileUrl1:any;
  backingTrackFileUrl2:any
  demoTrackFileUrl1:any
  demoTrackFileUrl2:any
  songFileUrl2:any;
  songFileUrl1:any;
  karaokeFileUrl1:any;
  karaokeFileUrl2:any;
  songId1:any
  songId2:any
  karaoke_url: any;
  annotationFileUrl: any | null;
  lyrics_id: any;
  annotation_id: any;
  song_id_1:any;
  song_id_2:any;
    demo_track_id_1: any;
    backing_track_id_1?: any; // Optional field
    backing_track_id_2?: any; // Optional field
  demo_track_id_2: any;
  karaoke_id_2: any; 
   karaoke_id_1: any;
  backing_track_id: any;
  songNotesId: any;
  lyricsId:any;
  mainSongFile1:any;
  mainSongFile2:any;
  demoTrackFile1:any;
  demoTrackFile2:any;
  songNotesFile:any;
  // backing_track_one_id: number;
  // backing_track_two_id: number;

  kids_friendly: boolean;
  lyricsFile: any | null;
  annotationFile: any | null;
 lyricsFileUrl:any|null;
 notation_link: any ;
 demoTrackUrl:any;


}


interface SonglistCardProps {
  toggle: () => void;
  levelId: number;
}

const SonglistCard: React.FC<SonglistCardProps> = ({ toggle, levelId, }) => {
  
  const [song, setSong] = useState<Song>({
    name: '',
    mainSongFile1: null,
    mainSongFile2: null,
    songUrl: '',
    mainLink: '',
    karaokeLink: '',
    karaokeFile1: null,
    karaokeFile2: null,
    notation_link: '',
    annotationFile: null,
    lyricsFile: null,
    backingTrackFile1: null,
    songsNotesFile:null,
    backingTrackFile2: null,
    demoTrackLink: '',
    demoTrackFile1: null,
    demoTrackFile2: null,
    kidFriendly: false,
  });
  
  
  const [songList, setSongList] = useState<FetchedSong[]>([]);
  const [isOpen, setIsOpen] = useState(false); 
  const [isSongListOpen, setIsSongListOpen] = useState(false); 
  const [addIsOpen, setAddIsOpen] = useState(false); 
  const [searchQuery, setSearchQuery] = useState('');
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
const [songToDelete, setSongToDelete] = useState<FetchedSong | null>(null);
const [isPreviewOpen, setIsPreviewOpen] = useState(false); // State to control preview modal
const [previewUrl, setPreviewUrl] = useState<string | null>(null); 
const [isUploading, setIsUploading] = useState(false); 
const [isEditModalOpen, setIsEditModalOpen] = useState(false);
const [songToEdit, setSongToEdit] = useState<FetchedSong | null>(null);
const [isChecked, setIsChecked] = useState(false); // Checkbox state
const [tags, setTags] = useState([]); // State to store fetched tags
const [selectedTags, setSelectedTags] = useState<any[]>([]); // Use string[] instead of number[]
const [selectedEditTags, setSelectedEditTags] = useState<any[]>([]); // Use string[] instead of number[]

const[songActive, setSongActive] = useState<any>('1');
const [modalOpen, setModalOpen] = useState(false);

const [selectedSong, setSelectedSong] = useState(null); 

const toggleModal = () => {

  setModalOpen(!modalOpen);
}
const handleViewSongDetails = (song : any) => {
  setSelectedSong(song);  // Set the selected song when the button is clicked
  toggleModal();          // Open the modal
};
const { tagsList, isLoading: tagsLoading } = tagsMap()
const tagOptions = tagsList.map((tag) => ({ value: tag.id, label: tag.name }));
  const fetchSongs = async () => {
    try {
      const response = await getSongLevel(levelId);
      if (response) {
        setSongList(response.songs);
      } else {
        console.log('Error fetching songs', response);
      }
    } catch (error) {
      console.error('Error fetching songs', error);
    }
  };
  
  useEffect(() => {
    if (songToEdit) {
      const initialTags = songToEdit.tags.map((tag : any) => ({ label: tag, value: tag })); // Convert tags to Select format // Set the initial selected tags when the modal is opened
    }
  }, [songToEdit]);
  

  useEffect(() => {
    fetchSongs();
  }, []);
  

  const songDetails: { key: keyof FetchedSong; label: any; newTab?: boolean }[] = [
    { key: "song_url", label: "Main Song Link", newTab: true }, // open in new tab
    { key: "karaokeFileUrl1", label: "Karaoke 1" },
    { key: "karaokeFileUrl2", label: "Karaoke 2" },
    { key: "karaoke_url", label: "Karaoke Link", newTab: true }, // open in new tab
    { key: "annotationFileUrl", label: "Notation File", },
    { key: "lyricsFileUrl", label: "Lyrics File" },
    { key: "notation_link", label: "Notation Link", newTab: true }, // open in new tab
    { key: "songFileUrl1", label: "Song File 1" },
    { key: "songFileUrl2", label: "Song File 2" },
    { key: "demo_track_url", label: "Demo Track", newTab: true }, // open in new tab
    { key: "demoTrackFileUrl1", label: "Demo Track 1" },
    { key: "demoTrackFileUrl2", label: "Demo Track 2" },
    { key: "backing_track_url", label: "Backing Track" , newTab: true},
    { key: "backingTrackFileUrl1", label: "Backing Track 1" },
    { key: "backingTrackFileUrl2", label: "Backing Track 2" },
    { key: "songNotesFileUrl", label: "Song Notes"},
      // { key: "backingTrackOneUrl", label: "Backing Track One" },
    // { key: "backingTrackTwoUrl", label: "Backing Track Two" },
    
  ];
  


  const toggleSongTab = (tab: string) => {
    setSongActive(tab);
  };
  const handleTagChange = (selectedOptions : any ) => {
    setSelectedTags(selectedOptions); 
  };


  const handleEditSong = async () => {
    if (!songToEdit) return;
  
    try {
      // Existing IDs
      let lyricsId = songToEdit.lyrics_id;
      let annotationId = songToEdit.annotation_id;
      let songId1 = songToEdit.song_id_1; // Added
      let songId2 = songToEdit.song_id_2; // Added
      let demoTrackId1 = songToEdit.demo_track_id_1; // Added
      let demoTrackId2 = songToEdit.demo_track_id_2; // Added
      let karaokeId1 = songToEdit.karaoke_id_1; // Added
      let karaokeId2 = songToEdit.karaoke_id_2; // Added
      let backingTrackId1 = songToEdit.backing_track_id_1; // Added
      let backingTrackId2 = songToEdit.backing_track_id_2; // Added
      let songNotesId = songToEdit.song_notes_id; // New field
  
      const uploadFile = async (file: File | null, currentId: string | null) => {
        if (file) {
          const response = await uploadSongFile(file);
          return response?.data?.resource[0]?.resource_id || currentId;
        }
        return currentId;
      };
  
      lyricsId = await uploadFile(songToEdit.lyricsFile, lyricsId);
      annotationId = await uploadFile(songToEdit.annotationFile, annotationId);
      songId1 = await uploadFile(songToEdit.mainSongFile1, songId1); // Added
      songId2 = await uploadFile(songToEdit.mainSongFile2, songId2); // Added
      demoTrackId1 = await uploadFile(songToEdit.demoTrackFile1, demoTrackId1); // Added
      demoTrackId2 = await uploadFile(songToEdit.demoTrackFile2, demoTrackId2); // Added
      karaokeId1 = await uploadFile(songToEdit.karaokeFile1, karaokeId1); // Added
      karaokeId2 = await uploadFile(songToEdit.karaokeFile2, karaokeId2); // Added
      backingTrackId1 = await uploadFile(songToEdit.backingTrackFile1, backingTrackId1); // Added
      backingTrackId2 = await uploadFile(songToEdit.backingTrackFile2, backingTrackId2); // Added
      songNotesId = await uploadFile(songToEdit.songsNotesFile, songNotesId);
  
      const body = {
        songName: songToEdit.song_name,
        songUrl: songToEdit.song_url,
        karaokeUrl: songToEdit.karaoke_url,
        demoTrackUrl: songToEdit.demo_track_url ,
        backingTrackUrl: songToEdit.backing_track_url,
        lyricsId,
        annotationId,
        songId1, // Added
        songId2, 
        demoTrackId1, 
        demoTrackId2, 
        karaokeId1, 
        karaokeId2, 
        backingTrackId1, 
        backingTrackId2, 
        songNotesId,
        notation_link: songToEdit.notation_link,
        kidsFriendly: songToEdit.kids_friendly,
        tags: selectedEditTags.map((tag) => tag.value),
      };
  
      const response = await editSong(songToEdit.song_id, body);
  
      if (response.status === 200) {
        fetchSongs();
        toast.success("Song updated successfully");
        closeEditModal();
      } else {
        toast.error("Failed to update song");
      }
    } catch (error) {
      console.error("Error updating song", error);
      toast.error("Error updating song");
    }
  };
  
  
  const handleInputChange = (field: keyof FetchedSong, value: any) => {
    if (songToEdit) {
      setSongToEdit({ ...songToEdit, [field]: value });
    }
  };

  const openEditModal = (song: FetchedSong) => {
    setIsEditModalOpen(true);
    const validTags = Array.isArray(song.tags)
      ? song.tags.filter((tag: any) => tag !== null )
      : [];
  
    // Map valid tags to match the `tagOptions` structure
    const initialTags = validTags.map((tag: any) => {
      const matchingTag = tagOptions.find((option) => option.label === tag);
      return matchingTag ? matchingTag : { label: tag, value: tag }; // Fallback to using the tag as both label and value
    });
  
    setSelectedEditTags(initialTags); // Update the selected tags state
    setSongToEdit({ ...song }); // Set the song being edited
 // Open the modal
  };
  
  
  
  
  
  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSongToEdit(null);
  };

  const handleAddFileChange = (file: File | null, key: string) => {
    if (file) {
      setSong({ ...song, [key]: file });
    }

  }


  const handleSongChange = (index: number, field: keyof Song, value: any) => {
    let updatedSong = { ...song };
    updatedSong = { ...updatedSong, [field]: value };
    setSong(updatedSong as any);
  };

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const clearFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = ''; // This resets the input field.
    }
  };
  const _addSong = async (newSong: any) => {
    setIsUploading(true);
    try {
      const response = await addSong(newSong);
      if (response.status === 201) {
        const songResponse = await addSongWithLevel({
          songs: [response.data.songId],
          levelId,
        });
        if (songResponse.status === 200) {
      
          setSong({
            name: '',
            mainSongFile1: null,
            mainSongFile2: null,
            songUrl: '',
            mainLink: '',
            karaokeLink: '',
            karaokeFile1: null,
            karaokeFile2: null,
            notation_link: '',
            annotationFile: null,
            lyricsFile: null,
            backingTrackFile1: null,
            songsNotesFile:null,
            backingTrackFile2: null,
            demoTrackLink: '',
            demoTrackFile1: null,
            demoTrackFile2: null,
            kidFriendly: false,
          });
  
          document.querySelectorAll('input[type="file"]').forEach((input) => {
            (input as HTMLInputElement).value = '';
          });
    
          fetchSongs();
          setSelectedTags([]);
          setIsUploading(false);
          toast.success('Song added successfully');
        } else {
          console.error('Error adding song to level', songResponse);
        }
      } else {
        console.error('Error adding song', response);
      }
    } catch (error) {
      console.error('Error adding song', error);
      toast.error('Error adding song');
    }
  };
  

  const openDeleteModal = (song: FetchedSong) => {
    setSongToDelete(song);
    setIsDeleteModalOpen(true);
  };
  
  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSongToDelete(null);
  };
  
  const handleDeleteSong = async () => {
    if (!songToDelete) return;
    try {
      const response = await removeSongFromLevel(songToDelete.song_id, levelId);
    
      if (response.status === 200) {
        fetchSongs(); // Refresh the song list after deletion
        toast.success('Song removed successfully');
      } else {
        console.log('Error removing song from level', response);
        toast.error('Error removing song from level');
      }
    } catch (error) {
      console.error('Error removing song from level', error);
      toast.error('Error removing song from level');
      console.log("songId", songToDelete.song_id, levelId)
    } finally {
      closeDeleteModal(); // Close the modal after processing
    }
  };
  
  

  const handleAddExistingSongs = async (songsToAdd: FetchedSong[]) => {
    try {
      // Filter out songs that are already in the songList by checking their song_id
      const newSongsToAdd = songsToAdd.filter(song => 
        !songList.some(existingSong => existingSong.song_id === song.song_id)
      );
  
      if (newSongsToAdd.length === 0) {
        // Show a toast message or notification if all songs are already in the list
        toast.error(' selected songs are already in the list');
        return;
      }
  
      const songIds = newSongsToAdd.map(song => song.song_id);
      const response = await addSongWithLevel({
        songs: songIds,
        levelId: levelId,
      });
  
      if (response.status === 200) {
        fetchSongs(); // Refresh the song list
        toast.success('New songs added successfully');
      } else {
        console.log('Error adding existing songs to level', response);
      }
    } catch (error) {
      console.error('Error adding existing songs to level', error);
    }
  };
  const filteredSongs = songList.filter(song => 
    song.song_name.toLowerCase().includes(searchQuery.toLowerCase())
  );
  

  const uploadSongFile = async (file: File) => {
    try {
      if (file) {
        const fileExtension = file.name.split('.').pop();
        let fName = file.name.split(' ').join('_'); // Replace spaces with underscores
        const response = await signedURL({ fileName: fName, fileType: fileExtension });
        if (response.status === 200) {
          let resourseName = response.data.fileName; // Update the resource name to match what the server expects
          const { signedUrl } = response.data;
          const uploadResponse = await uploadResourse(signedUrl, file);
          if (uploadResponse.status === 200) {
            const resourceResponse = await addResource({
              resourceName: resourseName,
              displayName: file.name,
              type: fileExtension,
              description: "", // Add your resource description here
              url: "", // Optional URL
            });

            if (resourceResponse.status === 200) {
              return resourceResponse;
            } else {
              console.log('Error adding resource', resourceResponse);
              return null;
            }
          } else {
            console.log('Error uploading file', uploadResponse);
            return null;
          }
        }
      }
    } catch (error) {
      console.error('Error during file upload process', error);
    }
  };

  const handlePreview = (fileUrl:any) => {
    setPreviewUrl(fileUrl);
    setIsPreviewOpen(true);
  };
  const closePreview = () => {
    setIsPreviewOpen(false);
    setPreviewUrl(null);
  };

  const handleAddSong = async () => {
    let uploadedFiles: UploadedFiles = {};
    setIsUploading(true);
  
    try {
      // Helper function to upload files
      const uploadFile = async (file: File | null, key: keyof UploadedFiles) => {
        if (file) {
          const response = await uploadSongFile(file);
          uploadedFiles[key] = response?.data?.resource[0]?.resource_id || null;
        }
      };
  
      // Upload all files
      await Promise.all([
        uploadFile(song.lyricsFile ?? null, "lyricsId"),
        uploadFile(song.annotationFile ?? null, "annotationId"),
        uploadFile(song.mainSongFile1 ?? null, "songId1"),
        uploadFile(song.mainSongFile2 ?? null, "songId2"),
        uploadFile(song.demoTrackFile1 ?? null, "demoTrackId1"),
        uploadFile(song.demoTrackFile2 ?? null, "demoTrackId2"),
        uploadFile(song.karaokeFile1 ?? null, "karaokeId1"),
        uploadFile(song.karaokeFile2 ?? null, "karaokeId2"),
        uploadFile(song.backingTrackFile1 ?? null, "backingTrackId1"),
        uploadFile(song.backingTrackFile2 ?? null, "backingTrackId2"),
        uploadFile(song.songsNotesFile ?? null, "songNotesId"), // Ensure null is passed instead of undefined
      ]);
      
  
      // Construct the song object
      const newSong = {
        songName: song.name,
        songUrl: song.mainLink,
        karaokeUrl: song.karaokeLink,
        lyricsId: uploadedFiles.lyricsId || null,
        annotationId: uploadedFiles.annotationId || null,
        kidsFriendly: song.kidFriendly,
        notation_link: song.notation_link,
        tags: selectedTags.map(tag => tag.value),
        songId1: uploadedFiles.songId1 || null,
        songId2: uploadedFiles.songId2 || null,
        karaokeId1: uploadedFiles.karaokeId1 || null,
        karaokeId2: uploadedFiles.karaokeId2 || null,
        demoTrackUrl: song.demoTrackLink,
        demoTrackId1: uploadedFiles.demoTrackId1 || null,
        demoTrackId2: uploadedFiles.demoTrackId2 || null,
        backingTrackUrl: song.backingTrackLink,
        backingTrackId1: uploadedFiles.backingTrackId1 || null,
        backingTrackId2: uploadedFiles.backingTrackId2 || null,
        songNotesId: uploadedFiles.songNotesId || null,
      };
  
      // Log and submit the payload
      console.log("New Song Payload:", newSong);
      await _addSong(newSong);
      toast.success("Song added successfully!");
    } catch (error) {
      console.error("Error adding song:", error);
      toast.error("Error adding song");
    } finally {
      setIsUploading(false);
    }
  };
  
  const handleFileChange = (file: File | null, key: string) => {
    if (songToEdit) {
      setSongToEdit({ ...songToEdit, [key]: file });
    }
  };
  

  const toggleCollapse = () => setIsOpen(!isOpen);
  const toggleSongListCollapse = () => setIsSongListOpen(!isSongListOpen);
  const toggleAddCollapse = () => setAddIsOpen(!addIsOpen);

  return (
<Card className="mb-3">
  <CardHeader onClick={toggleSongListCollapse} style={{ cursor: 'pointer' }}>
    <strong>Song List</strong>
    <Button
      color="link"
      onClick={toggleSongListCollapse}
      style={{ float: 'right', padding: '0', textDecoration: 'none' }}
    >
      {isSongListOpen ? '▼' : '►'}
    </Button>
  </CardHeader>
  <Collapse isOpen={isSongListOpen}>
    <CardBody style={{ maxHeight: '70vh', overflowY: 'auto' }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
        <Input
          type="text"
          placeholder="Search by title..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{ width: "250px" }}
        />
      </div>

      {filteredSongs.length > 0 ? (
        <ul style={{ maxHeight: '80vh', overflowY: 'auto', marginTop: '10px' }}>
          {filteredSongs.map((song,index) => (
           <Card key={song.song_id}>
           <Row className="d-flex align-items-center justify-content-between">
             {/* Title on the left */}
             <Col md="9">
               <strong>Title:</strong> {song.song_name}
             </Col>
         
             {/* Tags section */}
             <Col md="9">
               <strong>Tags:</strong>
               {Array.isArray(song.tags) && song.tags.length > 1 ? (
                 song.tags.map((tag, index) => (
                   <div key={index}>
                     {index + 1}. {tag}
                   </div>
                 ))
               ) : (
                 <span>{song.tags}</span> // If there is only one tag, show it as it is
               )}
             </Col>
            
             <Col md="2" className="d-flex justify-content-end gap-2">
             <Button color="secondary" onClick={() => handleViewSongDetails(song)}>
          <Eye size={18} />
               </Button>
               <Button onClick={() => openDeleteModal(song)}>
                 <Trash size={18} />
               </Button>
               <Button color="link" onClick={() => openEditModal(song)}>
                 <CiEdit size={18} />
               </Button>
             </Col>
           </Row>
         </Card>
         
          ))}
        </ul>
      ) : (
        <p>No songs added yet.</p>
      )}
       <Modal isOpen={modalOpen} toggle={toggleModal} className="custom-modal">
        <ModalHeader toggle={toggleModal}>Song Details</ModalHeader>
        <ModalBody>
          {selectedSong && (
            <ListGroup>
              {songDetails.map(({ key, label, newTab }) =>
                selectedSong[key] ? (
                  <ListGroupItem tag="div" action key={key}>
                    {newTab ? (
                      <a href={selectedSong[key]} target="_blank" rel="noopener noreferrer">
                        {label}
                      </a>
                    ) : (
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          handlePreview(selectedSong[key]);
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        {label}
                      </span>
                    )}
                  </ListGroupItem>
                ) : null
              )}
            </ListGroup>
          )}
        </ModalBody>
      </Modal>
    </CardBody>
  </Collapse>
  {songToEdit && (

<Modal isOpen={isEditModalOpen} toggle={closeEditModal}>
  <ModalHeader toggle={closeEditModal}>Edit Song</ModalHeader>
  <ModalBody style={{ maxHeight: '70vh', overflowY: 'auto' }}>
    {/* Shared Fields */}
    <FormGroup>
      <Label for="songName"><b>Song Name</b></Label>
      <Input
        type="text"
        id="songName"
        value={songToEdit?.song_name || ''}
        onChange={(e) => handleInputChange('song_name', e.target.value)}
      />
    </FormGroup>

    {/* Song URL */}
    <FormGroup>
      <Label for="songUrl"><b>Original Song Link</b></Label>
      <Input
        type="url"
        id="songUrl"
        value={songToEdit?.song_url || ''}
        onChange={(e) => handleInputChange('song_url', e.target.value)}
      />
    </FormGroup>
    <FormGroup>
      <Label><b>Original Song File 1</b></Label>
      <Input
        type="file"
        accept=".mp3,.wav,.m4a,.mp4"
        // value={songToEdit?.mainSongFile || ''}
        onChange={(e) =>
          handleFileChange(e.target.files ? e.target.files[0] : null, 'mainSongFile1')
        }
      />
    </FormGroup>
    <FormGroup>
      <Label><b>Original Song File 2</b></Label>
      <Input
        type="file"
        accept=".mp3,.wav,.m4a,.mp4"
        // value={songToEdit?.mainSongFile || ''}
        onChange={(e) =>
          handleFileChange(e.target.files ? e.target.files[0] : null, 'mainSongFile2')
        }
      />
    </FormGroup>
    <FormGroup>
      <Label for="karaokeUrl"><b>Karaoke URL</b></Label>
      <Input
        type="url"
        id="karaokeUrl"
        value={songToEdit?.karaoke_url || ''}
        onChange={(e) => handleInputChange('karaoke_url', e.target.value)}
      />
    </FormGroup>

    <FormGroup >
          <Label><b>Karaoke 1</b></Label>
          <Input
            type="file"
            accept=".mp3,.wav,.m4a,.mp4"
            // value={songToEdit?.karaokeAudioFile || ''}
            onChange={(e) =>
              handleFileChange(e.target.files ? e.target.files[0] : null, 'karaokeFile1')
            }        
          />
        </FormGroup>
        <FormGroup>
          <Label><b>Karaoke 2</b></Label>
          <Input
            type="file"
            accept=".mp3,.wav,.m4a,.mp4"
            // value={songToEdit?.karaokeVideoFile || ''}
            onChange={(e) =>
              handleFileChange(e.target.files ? e.target.files[0] : null, 'karaokeFile1')
            }
          
          />
        </FormGroup>
        <FormGroup className="mb-3">
      <Label><b>Demo Track</b></Label>
      <Input
        type="url"
        accept=".mp3,.wav,.m4a,.mp4"
        // value={songToEdit?.demoTrackFile|| ''}
        onChange={(e) => handleInputChange('demo_track_url', e.target.value)}
      />
    </FormGroup>

        <FormGroup className="mb-3">
      <Label><b>Demo Track 1</b></Label>
      <Input
        type="file"
        accept=".mp3,.wav,.m4a,.mp4"
        // value={songToEdit?.demoTrackFile|| ''}
        onChange={(e) =>
          handleFileChange(e.target.files ? e.target.files[0] : null, 'demoTrackFile1')
        }
      />
    </FormGroup>

        <FormGroup className="mb-3">
      <Label><b>Demo Track 2</b></Label>
      <Input
        type="file"
        accept=".mp3,.wav,.m4a,.mp4"
        // value={songToEdit?.demoTrackFile|| ''}
        onChange={(e) =>
          handleFileChange(e.target.files ? e.target.files[0] : null, 'demoTrackFile2')
        }
      />
    </FormGroup>

    {/* Backing Track Original Tempo */}
    <FormGroup className="mb-3">
      <Label><b>Backing Track Original Tempo</b></Label>
      <Input
        type="url"
        accept=".mp3,.wav,.m4a,.mp4"
        // value={songToEdit?.backingTrackFile|| ''}
        onChange={(e) => handleInputChange('backing_track_url', e.target.value)}

      />
    </FormGroup>
    <FormGroup className="mb-3">
  <Label><b>Backing Track Original Tempo 1</b></Label>
  <input
         className="form-control"
         ref={fileInputRef}
    type="file"
    accept=".mp3,.wav,.m4a,.mp4"
    onChange={(e) =>
      handleFileChange(e.target.files ? e.target.files[0] : null, 'backingTrackFile1')
    }  />
</FormGroup>
<FormGroup className="mb-3">
  <Label><b>Backing Track Original Tempo 2</b></Label>
  <input
         className="form-control"
         ref={fileInputRef}
    type="file"
    accept=".mp3,.wav,.m4a,.mp4"
    onChange={(e) =>
      handleFileChange(e.target.files ? e.target.files[0] : null, 'backingTrackFile2')
    }  />
</FormGroup>


    <FormGroup>
      <Label><b>Lyrics</b></Label>
      <Input
        type="file"
        accept=".pdf"
        // value={songToEdit?.lyricsFile|| ''}
        onChange={(e) =>
          handleFileChange(e.target.files ? e.target.files[0] : null, 'lyricsFile')
        }
      />
    </FormGroup>
    <FormGroup>
      <Label for="notationLink"><b>Notation Link</b></Label>
      <Input
        type="url"
        id="notationLink"
        value={songToEdit?.notation_link || ''}
        onChange={(e) => handleInputChange('notation_link', e.target.value)}
      />
    </FormGroup>
    <FormGroup>
      <Label><b>Notation File</b></Label>
      <Input
        type="file"
        accept=".pdf"
        // value={songToEdit?.annotationFile|| ''}
        onChange={(e) =>
          handleFileChange(e.target.files ? e.target.files[0] : null, 'annotationFile')
        }
      />
    </FormGroup>
 
    <FormGroup className="mb-3">
      <Label><b>Song Notes</b></Label>
      <Input
        type="file"
        accept=".mp3,.wav,.m4a,.mp4"
        // value={songToEdit?.demoTrackFile|| ''}
        onChange={(e) =>
          handleFileChange(e.target.files ? e.target.files[0] : null, 'songsNotesFile')
        }
      />
    </FormGroup>

 
    {/* <FormGroup className="mb-3">
      <Label><b>Backing Track Tempo 1</b></Label>
      <Input
        type="file"
        accept=".mp3,.wav,.m4a,.mp4"
        // value={songToEdit?.backingTrackOneFile|| ''}
        onChange={(e) =>
          handleFileChange(e.target.files ? e.target.files[0] : null, 'backingTrackOneFile')
        }
      />
    </FormGroup> */}

    {/* <FormGroup className="mb-3">
      <Label><b>Backing Track Tempo 2</b></Label>
      <Input
        type="file"
        accept=".mp3,.wav,.m4a,.mp4"
        // value={songToEdit?.backingTrackTwoFile|| ''}
        onChange={(e) =>
          handleFileChange(e.target.files ? e.target.files[0] : null, 'backingTrackTwoFile')
        }
      />
    </FormGroup> */}


    <FormGroup>
  <Label><b>Select Tags</b></Label>
  <Select
    isMulti
    value={selectedEditTags}
    options={tagOptions}
    onChange={(selectedOptions) => setSelectedEditTags(Array.from(selectedOptions || []))}
    placeholder="Select tags" // Optional: Add a placeholder
  />
</FormGroup>



  </ModalBody>
  <ModalFooter>
    <Button color="primary" onClick={handleEditSong}>
      Save Changes
    </Button>
    <Button color="secondary" onClick={closeEditModal}>
      Cancel
    </Button>
  </ModalFooter>
</Modal>



)}


  <CardHeader onClick={toggleAddCollapse} style={{ cursor: 'pointer' }}>
    <strong>Add Existing Song</strong>
    <Button
      color="link"
      onClick={toggleAddCollapse}
      style={{ float: 'right', padding: '0', textDecoration: 'none' }}
    >
      {addIsOpen ? '▼' : '►'}
    </Button>
  </CardHeader>
  <Collapse isOpen={addIsOpen}>
    <SongSearchComponent setSongs={handleAddExistingSongs} />
  </Collapse>

  <CardHeader onClick={toggleCollapse} style={{ cursor: 'pointer' }}>
    <strong>Add New Song</strong>
    <Button
      color="link"
      onClick={toggleCollapse}
      style={{ float: 'right', padding: '0', textDecoration: 'none' }}
    >
      {isOpen ? '▼' : '►'}
    </Button>
  </CardHeader>
  <Collapse isOpen={isOpen}>

    <CardBody style={{ maxHeight: '70vh', overflowY: 'auto' }}>
      <FormGroup className="mb-3">
        <Label for={`songName`}><b>Enter Song Name </b><span style={{ color: 'red' }}>*</span></Label>
        <Input
          type="text"
          id={`songName`}
          required
          value={song.name}
          onChange={(e) => handleSongChange(0, 'name', e.target.value)}
        />
      </FormGroup>
      <FormGroup className="mb-3">
        <Label for={`mainLink`}><b>Original Song Link</b> <span style={{ color: 'red' }}>*</span></Label>
        <Input
          type="url"
          
          id={`mainLink`}
          required
          value={song.mainLink}
          onChange={(e) => handleSongChange(0, 'mainLink', e.target.value)}
        />
      </FormGroup>

      <FormGroup className="mb-3">
  <Label for={`mainSongFile1`} ><b>Original Song File 1</b></Label>
  <input
         className="form-control"
         ref={fileInputRef}
  id={`mainSongFile1`}
    type="file"
    accept=".mp3,.wav,.m4a,.mp4,.mov,.avi,.mkv"
    onChange={(e) => setSong({ ...song, mainSongFile1: e.target.files ? e.target.files[0] : null })}
  />
</FormGroup>

<FormGroup className="mb-3">
  <Label for={`mainSongFile2`} ><b>Original Song File 2</b></Label>
  <input
         className="form-control"
         ref={fileInputRef}
  id={`mainSongFile`}
    type="file"
    accept=".mp3,.wav,.m4a,.mp4,.mov,.avi,.mkv"
    onChange={(e) => setSong({ ...song, mainSongFile2: e.target.files ? e.target.files[0] : null })}
  />
</FormGroup>
      <FormGroup className="mb-3">
        <Label for={`karaokeLink`}><b>Karaoke Song Link</b></Label>
        <Input
    className="form-control"

          type="url"
          id={`karaokeLink`}
          value={song.karaokeLink}
          onChange={(e) => handleSongChange(0, 'karaokeLink', e.target.value)}
        />
      </FormGroup>

      <FormGroup className="mb-3">
          <Label for={`karaokeFile1`} ><b>Karaoke 1</b></Label>
          <input
         className="form-control"
         ref={fileInputRef}
            type="file"
            id={`karaokeFile1`}
            accept=".mp3,.wav,.m4a,.mp4,.mov,.avi,.mkv"
            onChange={(e) =>
              setSong({ ...song, karaokeFile1: e.target.files ? e.target.files[0] : null })
            }
          />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for={`karaokeFile2`} ><b>Karaoke 2</b></Label>
          <input
         className="form-control"
         ref={fileInputRef}
         type="file"
                 id={`karaokeFile2`}
                 accept=".mp3,.wav,.m4a,.mp4,.mov,.avi,.mkv"
            onChange={(e) =>
              setSong({ ...song, karaokeFile2: e.target.files ? e.target.files[0] : null })
            }
          />
        </FormGroup>
      <FormGroup className="mb-3">
  <Label for={`demoTrackLink`} ><b>Demo Track</b></Label>
  <input
    className="form-control"
       ref={fileInputRef}
    type="url"
    accept=".mp3,.wav,.m4a,.mp4"
    onChange={(e) => handleSongChange(0, 'demoTrackLink', e.target.value)}  />
</FormGroup>
<FormGroup className="mb-3">
  <Label for={`demoTrackFile1`} ><b>Demo Track 1</b></Label>
  <input
    className="form-control"
       ref={fileInputRef}
    type="file"
    accept=".mp3,.wav,.m4a,.mp4,.mov,.avi,.mkv"
    onChange={(e) => setSong({ ...song, demoTrackFile1: e.target.files ? e.target.files[0] : null })}
  />
</FormGroup>

<FormGroup className="mb-3">
  <Label for={`demoTrackFile2`} ><b>Demo Track 2 </b></Label>
  <input
    className="form-control"
       ref={fileInputRef}
    type="file"
    accept=".mp3,.wav,.m4a,.mp4"
    onChange={(e) => setSong({ ...song, demoTrackFile2: e.target.files ? e.target.files[0] : null })}
  />
</FormGroup>

<FormGroup className="mb-3">
  <Label><b>Backing Track Original Tempo</b></Label>
  <input
         className="form-control"
         ref={fileInputRef}
    type="url"
    accept=".mp3,.wav,.m4a,.mp4,.mov,.avi,.mkv"
    onChange={(e) => handleSongChange(0, 'backingTrackLink', e.target.value)}  />

</FormGroup>

<FormGroup className="mb-3">
  <Label><b>Backing Track Original Tempo 1</b></Label>
  <input
         className="form-control"
         ref={fileInputRef}
    type="file"
    accept=".mp3,.wav,.m4a,.mp4"
    onChange={(e) => setSong({ ...song, backingTrackFile1 : e.target.files ? e.target.files[0] : null })}
  />
</FormGroup>
<FormGroup className="mb-3">
  <Label><b>Backing Track Original Tempo 2</b></Label>
  <input
         className="form-control"
         ref={fileInputRef}
    type="file"
    accept=".mp3,.wav,.m4a,.mp4,.mov,.avi,.mkv"
    onChange={(e) => setSong({ ...song, backingTrackFile2: e.target.files ? e.target.files[0] : null })}
  />
</FormGroup>

{/* <FormGroup className="mb-3">
  <Label><b>Backing Track Tempo 1</b></Label>
  <input
       className="form-control"
       ref={fileInputRef}
    type="file"
    accept=".mp3,.wav,.m4a,.mp4"
    onChange={(e) => setSong({ ...song, backingTrackOneFile: e.target.files ? e.target.files[0] : null })}
  />
</FormGroup>

<FormGroup className="mb-3">
  <Label  for={`backingTrackTwoFile`}><b>Backing Track Tempo 2</b></Label>
  <input
       className="form-control"
       ref={fileInputRef}
    type="file"
    id={`backingTrackTwoFile`}
    accept=".mp3,.wav,.m4a,.mp4"
    onChange={(e) => setSong({ ...song, backingTrackTwoFile: e.target.files ? e.target.files[0] : null })}
  />
</FormGroup> */}

  
<FormGroup className="mb-3">
        <Label for={`lyricsFile`}><b>Lyrics</b></Label>
        <input
          className="form-control"
          ref={fileInputRef}
          type="file"
          accept=".pdf"
          id={`lyricsFile`}
          onChange={(e) => setSong({ ...song, lyricsFile: e.target.files ? e.target.files[0] : null })}
          />
      </FormGroup>
      <FormGroup className="mb-3">
  <Label for={`uploadAnnotation`}><b>Notation Link</b></Label>
  <Input
  
    type="url"
    id={`uploadAnnotation`}
    value={song.notation_link} // Safe handling for null values

    onChange={(e) => handleSongChange(0, 'notation_link', e.target.value)}
  />
</FormGroup>

<FormGroup className="mb-3">
  <Label for={`annotationFile`}><b>Notation File</b></Label>
  <input
         className="form-control"
         ref={fileInputRef}

     accept=".pdf"
       type="file"
    id={`annotationFile`}

    // onChange={(e) => handleSongChange(0, 'notation_link', e.target.value)}
    onChange={(e) => setSong({ ...song, annotationFile: e.target.files ? e.target.files[0] : null })}

  />
</FormGroup>

<FormGroup className="mb-3">
      <Label><b>Song Notes</b></Label>
      <input
           className="form-control"
        type="file"
        accept=".mp3,.wav,.m4a,.mp4,.mov,.avi,.mkv"
        ref={fileInputRef}
        onChange={(e) => setSong({ ...song, songsNotesFile: e.target.files ? e.target.files[0] : null })}

      />
    </FormGroup>

    <div>
    <strong>Select Tags:</strong>
    <div>
      <Select
        isMulti
        value={selectedTags}
        options={tagOptions}
        onChange={handleTagChange} 
        placeholder="Select tags"
      />
     
    </div>
  </div>
  
     
    
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
        <Button
          disabled={isUploading}
          color="primary"
          onClick={handleAddSong}
          className="mb-3"
        >
          {isUploading ? (
            <Spinner size="sm" /> 
          ) : ('Save')}
        </Button>
      </div>
    </CardBody>
  </Collapse>

  <Modal isOpen={isDeleteModalOpen} toggle={closeDeleteModal}>
        <ModalHeader toggle={closeDeleteModal}>Confirm Deletion</ModalHeader>
        <ModalBody>
          Are you sure you want to delete the song{' '}
          <strong>{songToDelete?.song_name}</strong> from this level?
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={handleDeleteSong}>
            Delete
          </Button>
          <Button color="secondary" onClick={closeDeleteModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

  {/* Cancel Button */}
  <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
    <Button className="custom-cancel-button" style={{ marginTop: '20px' }} onClick={toggle}>
      Cancel
    </Button>
  </div>
  {previewUrl && (
    <PreviewModal
      isOpen={isPreviewOpen}
      toggle={closePreview}
      fileUrl={previewUrl}
      title="Preview"
    />
  )}
</Card>

  )};

export default SonglistCard;